"use client";

import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useBFFAuth } from "@/shared/hooks/useBFFAuth";
import LoginPage from "./login/page";

export default function Home() {
  const { isAuthenticated, isLoading, isLoggingOut } = useBFFAuth();
  const router = useRouter();

  useEffect(() => {
    // Check if this is an OAuth callback
    const url = new URL(window.location.href);
    const oauthSuccess = url.searchParams.get("oauth_success");
    const oauthError = url.searchParams.get("oauth_error");

    console.log("Root page check:", {
      oauthSuccess,
      oauthError,
      isAuthenticated,
    });

    // If it's an OAuth callback, DO NOT redirect - let the callback handle it
    if (oauthSuccess || oauthError) {
      console.log("OAuth callback detected - staying on page");
      return;
    }

    // Normal authentication flow
    if (!isLoading && isAuthenticated && !isLoggingOut) {
      router.replace("/projects");
    }
  }, [isAuthenticated, isLoading, isLoggingOut, router]);

  if (isLoading || isLoggingOut) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-muted-foreground">
          {isLoggingOut ? "Signing out..." : "Loading..."}
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-muted-foreground">Redirecting to dashboard...</div>
    </div>
  );
}
